import React from 'react';
import { useSameOrgAdvisors } from './useSameOrgAdvisors';
import { Box } from '../../../../../../../CommonComponents/OPL/Box/Box';
import { Label } from '../../../../../../../CommonComponents/OPL/Label/Label';
import { Select } from '../../../../../../../CommonComponents/OPL/Select/Select/Select';
import { CampaignAccessDTO } from '../../../../../../api/useCampaignAccessQuery';
import { Loading } from '../../../../../../../CommonComponents/OPL/Loading/Loading';
import { ErrorState } from '../../../../../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';

interface Props {
  campaignAccess: CampaignAccessDTO;
  setCampaignAccess(campaignAccess: CampaignAccessDTO): void;
}

export const SameOrgAdvisors: React.FC<Props> = ({ campaignAccess, setCampaignAccess }) => {
  const { isLoading, isError, options, refetch, data } = useSameOrgAdvisors({ campaignAccess });

  if (isLoading) {
    return (
      <Box my="56">
        <Loading text="Loading..." size="small" mx="auto" />
      </Box>
    );
  }

  if (isError) {
    return (
      <Box my="56">
        <ErrorState onAction={refetch} />
      </Box>
    );
  }

  if (options.length === 0) {
    return null;
  }

  const onAdvisorSelect = (adviserId: number) => {
    const foundAdvisor = data.find(advisor => advisor.adviserId === adviserId);

    if (foundAdvisor) {
      setCampaignAccess({
        ...campaignAccess,
        relationships: [
          ...campaignAccess.relationships,
          {
            ...foundAdvisor,
            isRemovable: true,
            isOwner: false,
          },
        ],
      });
    }
  };

  return (
    <Box my="16">
      <Label htmlFor="select--campaign-select-advisor" mb="4">
        Invite Advisors
      </Label>

      <Select
        id="campaign-select-advisor"
        options={options}
        placeholder="Select Advisor"
        onChange={opt => {
          if (opt) {
            onAdvisorSelect(opt.value);
          }
        }}
        menuPlacement="top"
      />
    </Box>
  );
};
